import { z } from 'zod';
import { mmSortByValues, mmStatusValues } from 'src/apis/iip-service/mappings';
import {
  descSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import {
  optionalDefault,
  preprocessAsArray,
} from 'src/components/form/zod-utilities';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { tsoOptionSchema } from 'src/pages/market-messages/maintenance-messages/overview/tso-searchable-multi-select';

const schema = z
  .object({
    sortBy: z.enum(mmSortByValues).default('PUBLICATION_DATE_TIME'),
    sortDirection: descSortDirectionSchema,
    tsoOperatorId: z.preprocess(
      preprocessAsArray,
      z.array(tsoOptionSchema).default([])
    ),
    eventPeriodFrom: z.string().nullable().default(null),
    eventPeriodTo: z.string().nullable().default(null),
    publicationDateTimeFrom: z.string().nullable().default(null),
    publicationDateTimeTo: z.string().nullable().default(null),
    identifier: z.string().max(100).nullable().default(null),
    status: z.preprocess(
      optionalDefault(['ACTIVE']),
      z.preprocess(preprocessAsArray, z.array(z.enum(mmStatusValues)))
    ),
  })
  .merge(getPaginationSchema());

export const useMmPageParams = () => {
  return usePageParamsFromSchema(schema, {
    filters: {
      tsoOperatorId: { label: 'TSO' },
      eventPeriodFrom: { label: 'Event Period' },
      eventPeriodTo: { label: 'Event Period' },
      publicationDateTimeFrom: { label: 'Publication Date' },
      publicationDateTimeTo: { label: 'Publication Date' },
      identifier: { label: 'Message ID' },
      status: { label: 'Status' },
      sortBy: { label: 'Sort Messages by' },
    },
  });
};

export type MmPageParams = ReturnType<typeof useMmPageParams>;
